import { useSource } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Button, Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router";
import { SIV_Order } from "../../../parsegenerated";

type Props = {
  order: SIV_Order;
};

export const NavigateToOrderButton = observer((props: Props) => {
  const t = useTranslation();
  const navigate = useNavigate();
  const [source, setSource, sources] = useSource();

  if (!props.order || !props.order.id) {
    return null;
  }

  // Sets the correct source for this order in source picker
  const setTenantSource = () => {
    if (
      props.order.get("tenant") &&
      props.order.get("tenant")!.get("dataSource") &&
      props.order.get("tenant")!.get("dataSource")!.id
    ) {
      setSource(props.order.get("tenant")?.get("dataSource")!.id!);
    }
  };

  return (
    <>
      <Tooltip
        title={t("siv:order.classconfig.entry.tooltip", {
          orderno: props.order.get("no"),
        })}
      >
        <Button
          type="text"
          icon={<Icon icon="fa:external-link" />}
          onClick={() => {
            setTenantSource();
            navigate(
              "/orders/details/" + props.order.id + "?hideSourcePicker=true",
            );
          }}
        />
      </Tooltip>
    </>
  );
});
